import { CalendarPlus, CalendarClock, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "./LanguageContext";
import { buildIcsContent, buildGoogleCalUrl } from "./config";

export default function SaveActions() {
  const { t } = useLanguage();

  const addToCalendar = () => {
    try {
      const blob = new Blob([buildIcsContent()], {
        type: "text/calendar;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "nurhan-en-emre.ics";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1500);
      toast.success(t.actions.calendarAdded);
    } catch {
      toast.error(t.actions.calendarError);
    }
  };

  const share = async () => {
    const shareData = {
      title: "Nurhan & Emre",
      text: t.actions.shareText,
      url: window.location.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }
    } catch {
      /* user cancelled – fall through to copy */
    }
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success(t.actions.shareCopied);
    } catch {
      toast.success(t.actions.shareCopied);
    }
  };

  return (
    <div className="mt-6 flex flex-wrap gap-3">
      <button
        onClick={addToCalendar}
        data-testid="add-calendar-button"
        className="group inline-flex items-center gap-2.5 rounded-full border border-turq/40 px-6 py-3 text-turq transition-colors duration-300 hover:bg-turq hover:text-cream"
      >
        <CalendarPlus className="h-4 w-4" strokeWidth={1.8} />
        <span className="font-sans text-xs uppercase tracking-[0.14em]">
          {t.actions.addCalendar}
        </span>
      </button>
      <a
        href={buildGoogleCalUrl()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="google-calendar-button"
        className="group inline-flex items-center gap-2.5 rounded-full border border-turq/40 px-6 py-3 text-turq transition-colors duration-300 hover:bg-turq hover:text-cream"
      >
        <CalendarClock className="h-4 w-4" strokeWidth={1.8} />
        <span className="font-sans text-xs uppercase tracking-[0.14em]">
          {t.actions.googleCalendar}
        </span>
      </a>
      <button
        onClick={share}
        data-testid="share-button"
        className="group inline-flex items-center gap-2.5 rounded-full border border-gold/50 px-6 py-3 text-ink transition-colors duration-300 hover:bg-gold hover:text-cream"
      >
        <Share2 className="h-4 w-4" strokeWidth={1.8} />
        <span className="font-sans text-xs uppercase tracking-[0.14em]">
          {t.actions.share}
        </span>
      </button>
    </div>
  );
}
